import MyCancellationStatusChip from './MyCancellationStatusChip';

const MyApprovedRequestsChip = () => <MyCancellationStatusChip variant="approved" />;

export default MyApprovedRequestsChip;
